import React, { useState } from "react";
import { auth, db } from "../../../config/firebaseConfig";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  OAuthProvider,
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import microsoftLogo from "../../../assets/microsoft-logo.png"; // Import the Microsoft logo
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebaseConfig";

const Login = () => {
  const [emailOrUsername, setEmailOrUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    if (isSubmitting) return;
    if (!emailOrUsername || !password) {
      alert("Email/Username and Password are required");
      return;
    }
    setIsSubmitting(true);

    try {
      // Attempt to sign in with email and password
      await signInWithEmailAndPassword(auth, emailOrUsername, password);
      const user = auth.currentUser;

      // Fetch the user's role from Firestore
      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (userDoc.exists()) {
        const userData = userDoc.data();
        const userRole = userData.role;

        // Set the custom claim for the user's role
        const setCustomClaims = httpsCallable(functions, "setCustomClaims");
        await setCustomClaims({ targetUid: user.uid, role: userRole });

        // Navigate to home page regardless of role
        navigate("/home");
      } else {
        console.error("User document not found");
        navigate("/");
      }
    } catch (error) {
      console.error("Login error:", error);
      const errorMessages = {
        "auth/wrong-password":
          "Invalid email/username or password. Please try again.",
        "auth/invalid-credential":
          "Invalid email/username or password. Please try again.",
        "auth/user-not-found": "User not found. Please try again.",
        "auth/invalid-email": "The email address is not valid.",
        "auth/user-disabled": "The user account has been disabled.",
        "auth/too-many-requests":
          "Too many login attempts. Please try again later.",
      };
      alert(errorMessages[error.code] || `Login failed: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleMicrosoftSignIn = async () => {
    const provider = new OAuthProvider("microsoft.com");
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Check if the user already exists in Firestore
      const userDoc = await getDoc(doc(db, "users", user.uid));

      if (!userDoc.exists()) {
        // User doesn't exist, create a new user
        const createUser = httpsCallable(functions, "createUser");
        const userData = {
          email: user.email,
          firstName: user.displayName ? user.displayName.split(" ")[0] : "",
          lastName: user.displayName
            ? user.displayName.split(" ").slice(1).join(" ")
            : "",
          username: user.email.split("@")[0],
          role: "student",
          providerId: "microsoft.com",
          isNewSignUp: true,
        };

        await createUser(userData);
        console.log("New user created");
      }

      // Fetch user data from Firestore (it will exist now)
      const updatedUserDoc = await getDoc(doc(db, "users", user.uid));
      const userData = updatedUserDoc.data();

      // Navigate to home page regardless of role
      navigate("/home");
    } catch (error) {
      console.error("Error signing in with Microsoft:", error);
      alert(`Failed to sign in with Microsoft: ${error.message}`);
    }
  };

  return (
    <div className="loginpage-main-content fade-in">
      <h1>S O C R A T E S</h1>
      <form className="loginpage-form" onSubmit={handleLogin}>
        <input
          type="text"
          className="loginpage-input"
          value={emailOrUsername}
          onChange={(e) => setEmailOrUsername(e.target.value)}
          placeholder="Email or Username"
        />
        <input
          type="password"
          className="loginpage-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
        />
        <div className="loginpage-button-group">
          <button
            type="submit"
            className="loginpage-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Logging in..." : "Login"}
          </button>
          <button
            type="button"
            className="loginpage-forgot-button"
            onClick={() => navigate("/forgot-password")}
          >
            Forgot password
          </button>
        </div>
      </form>
      <button
        onClick={handleMicrosoftSignIn}
        className="loginpage-microsoft-button"
      >
        <img src={microsoftLogo} alt="Microsoft Logo" />
        Sign in with Microsoft
      </button>
      <p className="loginpage-text">Not registered yet?</p>
      <button
        className="loginpage-signup-button"
        onClick={() => navigate("/signup")}
      >
        Sign up now!
      </button>
    </div>
  );
};

export default Login;
